import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../components/setAxios';
import config, { formaturl } from '../config/staticData';
import Blog from '../components/blog';
import StyledFlickity from '../components/styledFlickity';
import Loading from '../components/loading';
import Footer from '../components/footer';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Layout = ({ header: Header, betweenHeaderAndMain, children }) => {
    const flickityNewsOptions = {
        freeScroll: true,
        wrapAround: true,
        pageDots: false,
        contain: true,
        bgLazyLoad: 1
    };

    const [editorBlogs, setEditorBlogs] = useState([]);
    const [newsBlogs, setNewsBlogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            await Load();
            setLoading(false);
        })();
    }, []);

    async function Load() {
        const result = await api.get("/blog/GetBlogsByLikeCount");
        const newsBlog = await api.get("/blog/GetBlogsByOrderAsync");
        setEditorBlogs(result.data);
        setNewsBlogs(newsBlog.data);
    }

    const flickityNewsContent = editorBlogs.map((item, index) => {
        const blogId = item.id;
        const urlSlug = formaturl(item.title);
        return (
            <article key={index} className="carousel-news-cell">
                <div className="card-side card-front">
                    <Link to={`${process.env.REACT_APP_BASE_PATH}/${blogId}/${urlSlug}`} state={{ blogId }} >
                        <img src={`${config.blogPath}${item.blogPic}`} alt={item.title} />
                    </Link>
                    <div className="card-info">
                        <h4>{item.title}</h4>
                        <div className="card-footer">
                            <i className="fas fa-clock"></i>
                            <p>{item.publishDate}</p>
                        </div>
                    </div>
                </div>
            </article>
        );
    });

    return (
        <div>
            <Header />
            <div className="part-title">
                <h3>منتخب سردبیر</h3>
                <div className="sep"></div>
            </div>

            <section className='news'>
                {loading ? (
                    <Skeleton height={250} />
                ) : (
                    <StyledFlickity flickityOptions={flickityNewsOptions} flickityStyle={'carousel-news'} flickityContent={flickityNewsContent} />
                )}
            </section>

            {betweenHeaderAndMain}
            <main>{children}</main>

            <div className="part-title">
                <h3>جدیدترین مطالب</h3>
                <div className="sep"></div>
            </div>

            <section className='blog'>
                <div className='blog-body'>
                    {loading ? (
                        <>
                            <Skeleton height={300} />
                            <Skeleton height={300} />
                            <Skeleton height={300} />
                        </>
                    ) : (
                        newsBlogs.map((item, index) => (
                            <Blog key={index} data={item} />
                        ))
                    )}
                </div>
            </section>

            <div className="end-sep">
                <div className="sep"></div>
                <a href={`${process.env.REACT_APP_BASE_PATH}/new`} className="end-btn">مشاهده عناوین بیشتر</a>
            </div>
            <Footer />
        </div>
    );
};

export default Layout;
